const TransferHistoryTypes = {
    GET_TRANSFER_HISTORY_START:'GET_TRANSFER_HISTORY_START',
    GET_TRANSFER_HISTORY_SUCCESS:'GET_TRANSFER_HISTORY_SUCCESS',
    GET_TRANSFER_HISTORY_FAILED:'GET_TRANSFER_HISTORY_FAILED',

}

export default TransferHistoryTypes